import { User } from './user';

export interface IReportList {
  items: Report[];
  totalCount: number;
}

// tslint:disable-next-line:max-classes-per-file
export class Report {
  id: number;
  uid: string;
  name: string;
  description: string;
  reportType: string;
  metadata: string;
  config: ReportConfig;
  createdById: number;
  createdBy: User;
  reportCategory: enumReportCategory;
  createdByName: string;
  canDelete: boolean;

  constructor(report?) {
    report = report || {};
    this.uid = report.uid;
    this.id = report.id;
    this.name = report.name;
    this.description = report.description;
    this.reportType = report.reportType;
    this.config = report.config;
    this.createdById = report.createdById;
    this.createdBy = report.createdBy;
    this.reportCategory = report.reportCategory || enumReportCategory.System;
    this.createdByName = report.createdByName;
    this.canDelete = report.canDelete || false;
  }
}

// tslint:disable-next-line:max-classes-per-file
export class ReportConfig {
  groupBy: string | number;
  filterId: string | number;
  filterDataType: string;
  filterLabel: string;
  subFilterId: string | number;
  subFilterDataType: string;
  subFilterLabel: string;
  organisationFilterId: string | number;
  organisationFilterLabel: string;
  userFilterId: string | number;
  userFilterLabel: string;
  valueId: string | number;
  valueLabel: string;
  aggregate: string;
  options: ReportOptions;
  state: string;
  showChart: boolean;
  showData: boolean;
  chartType: string;
  returnType: enumGroupReportReturnType;
  subjectTypeId: number;
  processTypeId: number;
  reportType: enumReportType;
  includeRecordsNotLinkedToSubject: boolean;

  constructor(config) {
    config = config || {};
    this.groupBy = config.groupBy;
    this.filterId = config.filterId || config.groupBy;
    this.filterDataType = config.filterDataType;
    this.filterLabel = config.filterLabel;
    this.subFilterId = config.subFilterId;
    this.subFilterDataType = config.subFilterDataType;
    this.subFilterLabel = config.subFilterLabel;
    this.userFilterId = config.userFilterId;
    this.userFilterLabel = config.userFilterLabel;
    this.organisationFilterId = config.organisationFilterId;
    this.organisationFilterLabel = config.organisationFilterLabel;
    this.valueId = config.valueId || '';
    this.valueLabel = config.valueLabel || '';
    this.aggregate = config.aggregate || 'count';
    this.options = config.ReportOptions;
    this.state = config.state;
    this.showChart = config.showChart;
    this.showData = config.showData;
    this.chartType = config.chartType;
    this.returnType = config.returnType || enumGroupReportReturnType.Subject;
    this.subjectTypeId = config.subjectTypeId;
    this.processTypeId = config.processTypeId;
    this.reportType = config.reportType;
    this.includeRecordsNotLinkedToSubject =
      config.includeRecordsNotLinkedToSubject || false;
  }
}

// tslint:disable-next-line:max-classes-per-file
export class ReportGroupData {
  name: string;
  value: number;
}

// tslint:disable-next-line:max-classes-per-file
export class ReportListData {
  Reference: string;
  Category: string;
  GroupBy: string;
  Status: string;
  Value: string;
  Opened: string;
  Closed: string;
  User: string;
  Manager: string;
  PrimaryLink: string;
}

// tslint:disable-next-line:max-classes-per-file
export class ReportData {
  groupData: ReportGroupData[];
  listData: string;
}

// tslint:disable-next-line:max-classes-per-file
export class ReportOptions {
  dateType: string;
  reportType: string;
  dateFrom: string;
  dateTo: string;
  filters: string;
  subFilters: string;
  state: string;
  users: string;
  showUsers: boolean;
  showOrganisations: boolean;
  showSubFilters: boolean;
  includeArchived: boolean;
  organisations: string;
  organisationIncludeBlank: boolean = true;

  constructor(f?) {
    f = f || {};
    this.dateType = f.dateType;
    this.dateFrom = f.dateFrom;
    this.reportType = f.reportType;
    this.dateTo = f.dateTo;
    this.filters = f.filters;
    this.subFilters = f.subFilters || f.outcomeCodings;
    this.state = f.state;
    this.users = f.users;
    this.showOrganisations = f.showOrganisations || false;
    this.showUsers = f.showUsers || false;
    this.showSubFilters = f.showSubFilters || false;
    this.includeArchived = f.includeArchived || false;
    this.organisations = f.organisations;
    this.organisationIncludeBlank = f.organisationIncludeBlank || true;
  }
}

export enum enumGroupReportReturnType {
  Subject = 0,
  Process = 1,
  SubjectAndProcess = 2,
  Referral = 3,
}

export enum enumReportCategory {
  System = 0,
  Referral = 1,
}

export enum enumReportType {
  ConcernsByChannelSource = 0,
  ConcernsByStatus = 1,
  ConcernsByType = 2,
  WhistleblowerReportSource = 3,
  ConfidentialityBreakdown = 4,
  SatisfactionOutcome = 5,
  SubstantiationReports = 6,

  ReportFindingsPerEmployee = 7,
  AnonymousFollowUp = 8,
  IncidentvsReportDate = 9,
}
